export default __webpack_public_path__ + "static/media/banner2.8dd8a02e.svg";